/**
 * Customize to adjust styles on kit widget
 */

import { TableCellProductImage } from '@/components/blocks/ProductImage';
import { TableCellResponsiveContent } from '@/components/blocks/Table/TableCellResponsiveContent';
import { SpecsDrawer } from '@/components/content/Kit/parts/SpecsDrawer';
import { kitTableItemDetailsSX } from '@/components/content/Kit/styles/Table/itemDetails';
import { kitTableItemDetailsStack } from '@/components/content/Kit/styles/Table/itemDetailsStack';
import { useLocalization } from '@/data/Localization';
import { ItemDetails, KitTableData } from '@/data/types/Product';
import { Stack, Typography } from '@mui/material';
import { CellContext } from '@tanstack/react-table';
import { FC } from 'react';
import { CDN_BASE_URL, OpenSansFontWeights } from 'shared/custom/constants/commonConstants';

export const KitTableItemDetails: FC<CellContext<KitTableData, ItemDetails>> = ({ getValue }) => {
	const { thumbnail, name, partNumber, manufacturer, attributes } = getValue();
	const imgURL = `${CDN_BASE_URL}/productos/${partNumber}/${partNumber}-m.jpg`;
	const { SKU } = useLocalization('HDMProductDetail');
	const { alignItems, justifyContent } = kitTableItemDetailsStack;
	const nameFormatted = name.charAt(0) + name.slice(1).toLowerCase();

	return (
		<TableCellResponsiveContent sx={kitTableItemDetailsSX.cell}>
			<Stack
				alignItems={alignItems}
				justifyContent={justifyContent}
				sx={kitTableItemDetailsSX.cellContainer}
			>
				{thumbnail ? (
					<TableCellProductImage
						{...{ isThumbnail: true, src: imgURL, alt: name, sx: kitTableItemDetailsSX.image }}
					/>
				) : null}
				<Stack sx={kitTableItemDetailsSX.nameContainer}>
					<Typography variant="bodyBaseline">
						<span style={{ fontWeight: OpenSansFontWeights.semibold }}>{manufacturer}</span>{' '}
						{nameFormatted}
					</Typography>
					<Typography variant="bodySubText" sx={kitTableItemDetailsSX.sku}>
						{SKU.t()} {partNumber}
					</Typography>
					<SpecsDrawer product={getValue()} />
				</Stack>
			</Stack>
		</TableCellResponsiveContent>
	);
};
